<template>
    <table class="m-table-plain">
        <slot></slot>
    </table>
</template>